<div class="login-screen">
    <div class="row m-0">
        <div class="col-lg-7 p-0">
            <div class="contentLogin">
                <div class="logo-header">
                    <img src="assets/images/logo.svg" alt="" class="img-fluid" srcset="">
                    <h5 class="m-0">{{'DONT_HAVE_ACCOUNT' | translate }} &nbsp;<a (click)="onSignup()" class="fw-medium">{{'SIGN_UP' | translate }}!</a>
                    </h5>
                </div>
                <div class="loginbox">
                    <h2 class="text-left mb-4 fw-light">{{'SET_NEW_PASSWORD' | translate }}</h2>
                    <div *ngIf="name!=''">
                        <h5 class="fw-bold" *ngIf="name!=null&& name!=undefined && name!='' && name!=' '">{{'NAME' | translate }}: {{name}}
                        </h5>
                        <h5></h5>
                    </div>
                    <div *ngIf="customerReferenceId!=''">
                        <h5 class="fw-bold"
                            *ngIf="customerReferenceId!=null&& customerReferenceId!=undefined && customerReferenceId!='' && customerReferenceId!=' '">
                            {{'CUSTOMER_ID' | translate }}: {{customerReferenceId}}</h5>
                        <h5></h5>
                    </div>
                    <!-- <h6>By clicking on “Submit” we will verify your detail if the verification is successful then the you can set new password</h6> -->
                    <form class="login-form" [formGroup]="setNewPasswordForm" (ngSubmit)="form.form.valid"
                        #form="ngForm">
                        <div class="mb-3">
                            <mat-label>{{'PASSWORD' | translate }} </mat-label>
                            <div class="position-relative">
                                <input matInput class="w-100 form-control" [placeholder]="'PASSWORD' | translate"
                                    formControlName="password" type="{{passwordinputType}}">
                                <div (click)="changeInputType(passwordinputType,'password')">
                                    <mat-icon *ngIf="passwordinputType == 'password'" aria-hidden="false"
                                        aria-label="Visibility Off" fontIcon="visibility_off"></mat-icon>
                                    <mat-icon *ngIf="passwordinputType == 'text'" aria-hidden="false"
                                        aria-label="Visibility On" fontIcon="visibility_on"></mat-icon>
                                </div>
                                <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon=" visibility_off"></mat-icon> -->
                                <mat-error class="text-danger"
                                    *ngIf="(form.submitted || setNewPasswordForm.get('password')?.touched) && setNewPasswordForm.controls['password'].errors?.['required']">
                                    {{'PASSWORD_REQUIRED_MSG' | translate }}
                                </mat-error>
                                <mat-error class="text-danger" *ngIf="(form.submitted || setNewPasswordForm.get('password')?.touched) &&
                                       setNewPasswordForm.get('password')?.hasError('pattern')">
                                    {{'PASSWORD_VALIDATION_MSG' | translate }}
                                </mat-error>
                            </div>
                        </div>
                        <div class="mb-3">
                            <mat-label>{{'CONFIRM_PASSWORD' | translate }} </mat-label>
                            <div class="position-relative">
                                <input matInput class="w-100 form-control" [placeholder]="'CONFIRM_PASSWORD' | translate"
                                    formControlName="confirmPassword" type="{{confirmPasswordinputTypes}}">
                                <div (click)="changeInputType(confirmPasswordinputTypes,'confirmPassword')">
                                    <mat-icon *ngIf="confirmPasswordinputTypes == 'password'" aria-hidden="false"
                                        aria-label="Visibility Off" fontIcon="visibility_off"></mat-icon>
                                    <mat-icon *ngIf="confirmPasswordinputTypes == 'text'" aria-hidden="false"
                                        aria-label="Visibility On" fontIcon="visibility_on"></mat-icon>
                                </div>
                                <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon=" visibility"></mat-icon> -->
                                <mat-error class="text-danger"
                                    *ngIf="(form.submitted || setNewPasswordForm.get('confirmPassword')?.touched) && setNewPasswordForm.controls['confirmPassword'].errors?.['required']">
                                    {{'CONFIRM_PASSWORD_REQUIRED_MSG' | translate }}
                                </mat-error>
                                <mat-error class="text-danger"
                                    *ngIf="(setNewPasswordForm.get('confirmPassword')?.touched) && setNewPasswordForm.controls['confirmPassword'].value!=setNewPasswordForm.controls['password'].value">
                                    {{'PASSWORD_NOT_MATCHED_MSG' | translate }}
                                </mat-error>
                            </div>
                        </div>
                        <!-- <div class="mb-3">
                           <p>By clicking on “Submit” we will verify your detail if the verification is successful then the link to regenerate the OTP will be sent to Email Address.
                        </p>
                        </div> -->
                        <button mat-flat-button color="primary" class="my-3 w-100" (click)="onSubmit()">{{'SUBMIT' | translate }}</button>

                    </form>
                </div>
            </div>

        </div>
        <div class="col-lg-5 p-0">
            <div class="image-height setnewpassword-bg">
                <p>&nbsp;</p>
            </div>

        </div>
    </div>
</div>